export function getTrackerOrigin(): string {
  const fromEnv = String(import.meta.env.VITE_PUBLIC_ORIGIN || '').replace(/\/$/, '');
  if (fromEnv) return fromEnv;
  if (typeof window === 'undefined') return '';
  return window.location.origin;
}

export function buildSnippet(trackingCode: string, origin = getTrackerOrigin()): string {
  return `<script async src="${origin}/t.js" data-sf="${trackingCode}"></script>`;
}
